/**
 * Class StickyAnchorBar
 */
class StickyAnchorBar {
	anchorBar: HTMLElement;
	trigger: HTMLElement;
	overlay: HTMLElement;
	links: NodeListOf<HTMLElement>;

	constructor(element: HTMLElement) {
		this.anchorBar = element;
		this.trigger = this.anchorBar.querySelector(
			'.block-sticky-anchor-bar__toggle'
		) as HTMLElement;
		this.overlay = this.anchorBar.querySelector(
			'.block-sticky-anchor-bar__overlay'
		) as HTMLElement;
		this.links = this.anchorBar.querySelectorAll(
			'.block-sticky-anchor-bar__link'
		) as NodeListOf<HTMLElement>;
	}

	init() {
		this.trigger.addEventListener('click', this.handleTriggerClick.bind(this));
		this.overlay.addEventListener('click', this.handleOverlayClick.bind(this));
		this.links.forEach((link) => {
			link.addEventListener('click', this.handleTriggerClick.bind(this));
		});

		window.addEventListener('resize', () => {
			this.handleResize();
		});
	}

	handleResize() {
		const links = this.anchorBar.querySelector(
			'.block-sticky-anchor-bar__links'
		) as HTMLElement;

		if (window.innerWidth >= 768) {
			this.overlay.style.display = 'none';
			this.overlay.style.opacity = '0';
			if (null !== links) {
				links.setAttribute('aria-expanded', 'false');
				links.classList.remove('block-sticky-anchor-bar__links--expanded');
				links.style.display = 'flex';
				links.style.opacity = '1';
			}
		} else if (links) {
			links.style.display = 'none';
		}
	}

	handleTriggerClick(event: Event) {
		const target = event.currentTarget as HTMLElement;

		if (window.innerWidth < 768) {
			const isExpanded = target
				?.closest('.block-sticky-anchor-bar')
				?.querySelector('.block-sticky-anchor-bar__links')
				?.classList.contains('block-sticky-anchor-bar__links--expanded');

			if (isExpanded) {
				this.collapseDropdown(target);
			} else {
				this.expandDropdown(target);
			}
		}
	}

	handleOverlayClick(event: Event) {
		const target = event.currentTarget as HTMLElement;

		const isExpanded = target
			?.closest('.block-sticky-anchor-bar')
			?.querySelector('.block-sticky-anchor-bar__links')
			?.classList.contains('block-sticky-anchor-bar__links--expanded');

		if (isExpanded) {
			this.collapseDropdown(target);
		}
	}

	expandDropdown(element: HTMLElement) {
		const parent = element.closest('.block-sticky-anchor-bar') as HTMLElement;
		const dropdown = parent.querySelector('.block-sticky-anchor-bar__links') as HTMLElement;

		dropdown.setAttribute('aria-expanded', 'true');
		dropdown.classList.add('block-sticky-anchor-bar__links--expanded');
		dropdown.style.display = 'flex';
		this.overlay.style.display = 'block';
		setTimeout(() => {
			this.overlay.style.opacity = '0.7';
			dropdown.style.opacity = '1';
		}, 10);
	}

	collapseDropdown(element: HTMLElement) {
		const parent = element.closest('.block-sticky-anchor-bar') as HTMLElement;
		const dropdown = parent.querySelector('.block-sticky-anchor-bar__links') as HTMLElement;

		dropdown.setAttribute('aria-expanded', 'false');
		dropdown.classList.remove('block-sticky-anchor-bar__links--expanded');
		dropdown.style.opacity = '0';
		this.overlay.style.opacity = '0';
		setTimeout(() => {
			this.overlay.style.display = 'none';
			dropdown.style.display = 'none';
		}, 300);
	}
}

document.querySelectorAll<HTMLElement>('.block-sticky-anchor-bar').forEach((element) => {
	new StickyAnchorBar(element).init();
});
